/* eslint-disable import/extensions,import/no-unresolved,import/no-duplicates */
import { stepBaggageAndPersonalItemsStarrLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire(data, claimCode) {
  const questionnaire = [];
  const entries = Object.entries(data);
  const excludedEntries = ['descriptionOfItems',
    'descriptionOfItemsForDamaged',
    'specifiedItems',

    "flightDetailsForBaggageDelay",
    "cruiseLineDetailsBaggageDelay",
    "otherDetailsBaggageDelay",

    "flightDetailsForDamaged",
    "cruiseLineDetailsForDamaged",
    "otherDetailsForDamaged",

    "flightDetailsForBaggageDelay",
    "cruiseLineDetailsForBaggageDelay",
    "otherDetailsForBaggageDelay",
  ];
  entries.forEach(([property, value]) => {
    if (excludedEntries.indexOf(property) < 0) {
      questionnaire.push({
        question: `baggageAndPersonalItemsStarr.${property}`,
        answer: value,
        claimTypeCode: claimCode,
      });
    }
  });
  return [...questionnaire];
}

function mapToExpenses(data) {
  const damagedLostExpenses = mapToDamagedLostExpense(data);
  const baggageDelayExpenses = mapToBaggageDelayExpense(data);

  const benefitName = 'Baggage and Personal Items';
  const expenses = [
    ...damagedLostExpenses,
    ...baggageDelayExpenses,
  ].map(e => ({ ...e, benefitName }));
  return expenses;
}

function mapToClaimExpensesLevel(data, claimTypes, selectedBenefits) {
  const { areYouClaimingForDamagedLostOrStolenLuggage, areYouClaimingForBaggageDelay } = data;
  const list = [];
  const selected =
    !!selectedBenefits && typeof selectedBenefits.toJS === 'function'
      ? selectedBenefits.toJS()
      : selectedBenefits || [];
  const claimCodeList = expenseLookup.claimCodeList;
  if (selected.length > 0 && !selected.some((sel) => claimCodeList.includes(sel.claimCode))
  ) {
    return list;
  }
  if ((areYouClaimingForDamagedLostOrStolenLuggage === 'true' || areYouClaimingForBaggageDelay === 'true') && claimTypes !== undefined) {
    // claimCode is empty in the lookup; the real codes live in associatedClaimCodes.
    const code1List = expenseLookup.areYouClaimingForDamaged.associatedClaimCodes || [];
    const code2List = expenseLookup.areYouClaimingForBaggageDelay.associatedClaimCodes || [];
    const damagedLostExpenses = mapToDamagedLostExpense(data);
    const baggageDelayExpenses = mapToBaggageDelayExpense(data);
    claimTypes.forEach(
      (item) => {
        if (code1List.includes(item.claimCode) && areYouClaimingForDamagedLostOrStolenLuggage === 'true') {
          const benefit = mapClaimExpensesLevelItem(item, 'Damaged/Lost/Stolen Luggage', damagedLostExpenses);
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if (code2List.includes(item.claimCode) && areYouClaimingForBaggageDelay === 'true') {
          const benefit = mapClaimExpensesLevelItem(item, 'Baggage Delay', baggageDelayExpenses);
          if (!!benefit) {
            list.push(benefit);
          }
        }
      }
    );
  }

  return list;
}

function mapToDamagedLostExpense(data) {
  if (data.areYouClaimingForDamagedLostOrStolenLuggage !== 'true' || data.descriptionOfItems.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.areYouClaimingForDamaged.claimCode;
  const expenses = [];

  data.descriptionOfItems.forEach(
    (item) => {
      const expense = mapLossItemExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapToBaggageDelayExpense(data) {
  if (data.areYouClaimingForBaggageDelay !== 'true' || data.descriptionOfItemsForDamaged.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.areYouClaimingForBaggageDelay.claimCode;
  const expenses = [];

  data.descriptionOfItemsForDamaged.forEach(
    (item) => {
      const expense = mapDelayItemExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapLossItemExpense(item, formData, claimCode) {
  return mapExpenseItem(item, item.dateOfPurchase, claimCode);
}

function mapDelayItemExpense(item, formData, claimCode) {
  return mapExpenseItem(item, formData.dateWhenYourLuggageWasDelayed, claimCode);
}

function mapExpenseItem(item, itemDate, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountClaimed || !item.currentClaimed) {
    return null;
  }
  return {
    shortDescription: `${item.item}`,
    dateOfExpense: itemDate,
    clientCost: item.amountClaimed,
    currency: item.currentClaimed,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    dateOfPurchase: item.dateOfPurchase,
    depreciationType: item.depreciationType,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapReimbursement(item, formData, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.howMuch || !item.currencyExpensesClaimed || item.haveYouReceivedReimbursement !== 'true') {
    return null;
  }
  return {
    shortDescription: `${item.fromWhom} (Reimbursement)`,
    dateOfExpense: item.dateReimbursementReceived,
    clientCost: `${item.howMuch * -1}`,
    currency: item.currencyExpensesClaimed,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapClaimExpensesLevelItem(claimType, description, expenses) {
  return {
    claimCode: claimType.claimCode,
    description,
    claimTypeId: claimType.claimTypeId,
    requiredDocuments: claimType.requiredDocuments,
    order: null,
    expenses: expenses || [],
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
  mapToClaimExpensesLevel,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepBaggageAndPersonalItemsStarrDataMapper.js